import { render, staticRenderFns } from "./FooterDashboard.vue?vue&type=template&id=666bdb0a&"
import script from "./FooterDashboard.vue?vue&type=script&lang=js&"
export * from "./FooterDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports